<template>
  <search-body />
</template>

<script>
import SearchNetworking from "@/components/searchNetworking/SearchNetworking.vue";

export default {
  name: "SearchNetworking",
  components: {
    "search-body": SearchNetworking,
  },
};
</script>
